import { Component } from 'react';
import PropTypes from 'prop-types';

/**
* Class PermissionCheck
* PermissionCheck manage components rendering from permissions
**/
class PermissionCheck extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.hasPermission = false;
  }

  /**
  * getUserPermissions
  * Get user permissions array from context
  **/
  getUserPermissions() {
    return (this.context.user !== null) ? this.context.user.permissions : [];
  }

  /**
  * getPermission
  * Check the permission from props
  **/
  getPermission() {

    if(this.props.component === "Allow") {
      this.hasPermission = true;
    }

    const permissions = this.getUserPermissions();

    if(permissions[this.props.component] !== undefined) {
      this.hasPermission = (permissions[this.props.component][this.props.permission] === true);

    }

    return this.hasPermission;
  }

  /**
  * render
  * Rendering component function : display or not the children
  **/
  render() {
    return (this.getPermission()) ? this.props.children : null;
    //return this.props.children;
  }

}

PermissionCheck.contextTypes = {
  user: PropTypes.object.isRequired
}

PermissionCheck.propTypes = {
  component: PropTypes.string.isRequired,
  permission: PropTypes.string.isRequired
}

export default PermissionCheck;



// WEBPACK FOOTER //
// ./src/views/Permissions/PermissionCheck.js